export const GET_TESI_INVOICES_INIT = 'GET_TESI_INVOICES_INIT'
export const GET_TESI_INVOICES_SUCCESS = 'GET_TESI_INVOICES_SUCCESS'
export const GET_TESI_INVOICES_ERROR = 'GET_TESI_INVOICES_ERROR'
export const GET_TESI_INVOICES_RESET = 'GET_TESI_INVOICES_RESET'

export const RETRY_INVOICE_INIT = 'RETRY_INVOICE_INIT'
export const RETRY_INVOICE_SUCCESS = 'RETRY_INVOICE_SUCCESS'
export const RETRY_INVOICE_ERROR = 'RETRY_INVOICE_ERROR'
export const RETRY_INVOICE_RESET = "RETRY_INVOICE_RESET"